import React from 'react';
import Modal from '@blaze-react/modal';
import ReactDOM from 'react-dom';
import usePortal from '../../hooks/use-portal';

const ModalAdapter = ({ ...props }) => {
  const target = usePortal();

  return ReactDOM.createPortal(<Modal {...props} />, target);
};

export default ModalAdapter;
